import React from 'react';
import SuitesWorkspace from './SuitesWorkspace';

const TestSuitesPage = () => <SuitesWorkspace />;

export default TestSuitesPage;
